import * as lexActionType from '../actionsType/lexRecommandedLearning.actionType';

export const initialState = {
    status: lexActionType.FETCH_LEX_RECLEARN,
    response: null,
    exception: null
};

export function lexRecommandedLearningReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.LEX_RECLEARN_SUCCESS:
            return {...state, response: [...action.payload], status: lexActionType.LEX_RECLEARN_SUCCESS};
        case lexActionType.LEX_RECLEARN_ERROR:
            return {...state, status: lexActionType.LEX_RECLEARN_ERROR};
        default:
            return state;
    }
}
